<template>
  <div class="page">
    <a-table
      class="sec"
      size="small"
      :rowKey="(record) => record.id"
      bordered
      :columns="columns"
      :data-source="list"
      :pagination="false"
    >
      <template slot="headimgurl" slot-scope="text, record">
        <img style="height: 32px" :src="record.headimgurl" alt="">
      </template>
    </a-table>

    <a-pagination
      class="pagination"
      showQuickJumper
      v-model="page.now_page"
      :defaultPageSize="page.page_size"
      :total="page.amount"
      @change="changePage"
    />
  </div>
</template>

<style lang='scss' scoped>
</style>

<script>
const columns = [
  {
    title: "#",
    dataIndex: "id",
  },
  {
    title: "头像",
    scopedSlots: {
      customRender: "headimgurl",
    },
  },
  {
    title: "昵称",
    dataIndex: "nickname",
  },
  {
    title: "手机",
    dataIndex: "tel",
  },
  {
    title: "签到时间",
    dataIndex: "created_at",
  }
];

export default {
  data() {
    return {
      columns,
      list: [],
      activity_id: 0,
      page: {
        now_page: 1,
        page_size: 50,
        amount: 0,
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    changePage(e) {
      this.page.now_page = e;
      this.getList();
    },

    async getList() {
      const page = this.page.now_page;
      const r = await this.$axios.get("/checkin/getList", {
        params: {
          page,
          activity_id: 0
        },
      });

      if (r.status != 1) return;

      this.list = r.list;
      this.page.amount = r.amount;
    }
  },
};
</script>